import { useEffect } from 'react';

import { createNotification } from '../helpers';
import type { NotificationState, WarnProps } from '../index';

type UseWarnProps = NotificationState & WarnProps & {};

const useErrorNotification = ({
  warnTitle,
  warnMessage,
  notifications,
  setNotifications
}: UseWarnProps) => {
  useEffect(() => {
    const canCreateMsg = warnMessage || warnTitle;
    if (!canCreateMsg) return;

    const newNotification = createNotification({
      notifications,
      setNotifications,
      title: warnTitle,
      type: 'warning',
      description: warnMessage
    });
    const newNotifications = [...notifications, newNotification];

    setNotifications(newNotifications);
  }, [warnMessage, warnTitle]);
};

export default useErrorNotification;
